import { render, staticRenderFns } from "./DividerComponent.vue?vue&type=template&id=75a2eb80"
import script from "./DividerComponent.vue?vue&type=script&lang=ts"
export * from "./DividerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports